<script lang="ts">
  import FullScreenMessage from './FullScreenMessage.svelte'
  import translationsStore from '../../stores/translations.svelte'
  import videoStore from '../../stores/video.svelte'
  import Poster from '../Poster.svelte'
</script>

{#if videoStore.state.isChromecasting}
  <Poster />
  <FullScreenMessage class="text-white bg-black/75 text-shadow"
    ><span class="inline-block pb-10"
      >{`${translationsStore.state.chromecasting} ${videoStore.state.chromecastDeviceName ?? translationsStore.state.chromecast}`}</span
    ></FullScreenMessage
  >
{/if}
